<template>
  <div v-if="pmrObj">
    <legend class="pt-3">Primers</legend>
    <div class="py-2 list-group list-group-flush">
      <div
        class="list-group-item mb-1"
        v-for="(cstb, index) in pmrObj.cstbs"
        :key="index"
      >
        <div v-bind:class="cstb.use_seq_as_color">
          {{ cstb.display_name }}
        </div>
        <div
          v-if="pmrObj.forwards[index].olab_id"
          class="form-text text-left text-dark bg-light"
        >
          <div class="mb-1">
            <span class="small font-italic text-secondary mr-1">Name:</span>
            <span class="text-dark mr-2"
              >{{ pmrObj.forwards[index].name }}
            </span>
            <span class="small font-italic text-secondary mr-1">ID:</span>
            <span class="text-dark mr-2"
              >{{ pmrObj.forwards[index].olab_id }}
            </span>
            <span class="small font-italic text-secondary mr-1">Length:</span>
            <span class="text-dark mr-2"
              >{{ pmrObj.forwards[index].seq.length }}
            </span>
            <span class="small font-italic text-secondary mr-1">Tm:</span>
            <span class="text-dark mr-2"
              >{{ pmrObj.forwards[index].tm.toFixed(1) }}&#8451;
            </span>
          </div>
          <small>
            <span class="text-primary">
              <font-awesome-icon icon="long-arrow-alt-right" />
            </span>
            <span class="text-monospace text-primary ml-1"
              >{{ pmrObj.forwards[index].seq }}
            </span>
          </small>
        </div>
        <div v-else class="form-text text-left text-dark bg-light">
          <div class="mb-1">
            <span class="small font-italic text-secondary mr-1"
              >No forward primer</span
            >
          </div>
        </div>
        <div
          v-if="pmrObj.backwards[index].olab_id"
          class="form-text text-left text-dark bg-light"
        >
          <div class="mb-1">
            <span class="small font-italic text-secondary mr-1">Name:</span>
            <span class="text-dark mr-2"
              >{{ pmrObj.backwards[index].name }}
            </span>
            <span class="small font-italic text-secondary mr-1">ID:</span>
            <span class="text-dark mr-2"
              >{{ pmrObj.backwards[index].olab_id }}
            </span>
            <span class="small font-italic text-secondary mr-1">Length:</span>
            <span class="text-dark mr-2"
              >{{ pmrObj.backwards[index].seq.length }}
            </span>
            <span class="small font-italic text-secondary mr-1">Tm:</span>
            <span class="text-dark mr-2"
              >{{ pmrObj.backwards[index].tm.toFixed(1) }}&#8451;
            </span>
          </div>
          <small>
            <span class="text-danger">
              <font-awesome-icon icon="long-arrow-alt-left" />
            </span>
            <span class="text-monospace text-danger ml-1"
              >{{ pmrObj.backwards[index].seq }}
            </span>
          </small>
        </div>
        <div v-else class="form-text text-left text-dark bg-light">
          <div class="mb-1">
            <span class="small font-italic text-secondary mr-1"
              >No reverse primer</span
            >
          </div>
        </div>
      </div>
    </div>
    <legend class="pt-3">Construct</legend>
    <div class="py-2 text-left text-monospace small">
      <span
        style="word-break: break-all"
        v-for="(cstb, index) in pmrObj.cstbs"
        :key="index"
      >
        <span v-bind:class="cstb.use_seq_as_color">{{ cstb.seq }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "olabconstruct",
  props: ["pmrObj"],
  components: {
    FontAwesomeIcon
  }
};
</script>
